<template>
  <div id="program-detail-tab-id" class="pt-dtl-tab-bg">
    <div v-if="!loadingProgram">
      <b-card no-body class="custom-tab mb-4">
        <b-tabs card lazy>
          <b-tab
            title="Overview"
            @click.prevent="setDetailCurrentTab('overview_programs', 'program-detail-tab-id', datas.description)"
            :active="getDetailActiveTab === 'overview_programs'"
          >
            <overview-tab-section :data="datas"/>
          </b-tab>
          <b-tab
            @click.prevent="setDetailCurrentTab('program_logistics_programs', 'program-detail-tab-id')"
            :active="getDetailActiveTab === 'program_logistics_programs'"
          >
            <template #title>
              {{tabModal.logistics_tab_name ? tabModal.logistics_tab_name : 'Program Logistics'}}
              <i
                class="fa fa-edit custom-fa-edit-color"
                v-b-tooltip.hover.top
                title="Edit tab name"
                v-b-modal="'tabFormModal'"
                v-if="canEditCms"
              />
            </template>
            <program-logistics-tab-section :data="datas"/>
          </b-tab>
          <b-tab
            title="Notes"
            @click.prevent="setDetailCurrentTab('notes_programs', 'program-detail-tab-id')"
            :active="getDetailActiveTab === 'notes_programs'"
            v-if="canEditCms"
          >
            <schedule-and-notes-tab-section :data="datas"/>
          </b-tab>
          <b-tab
            title="Videos"
            :active="getDetailActiveTab === 'videos_programs'"
            @click.prevent="setDetailCurrentTab('videos_programs', 'program-detail-tab-id')"
          >
            <program-video-tab-section />
          </b-tab>
          <b-tab
            title="Programmatic Workshops"
            :active="getDetailActiveTab === 'programmatic_workshops_programs'"
            @click.prevent="setDetailCurrentTab('programmatic_workshops_programs', 'program-detail-tab-id')"
          >
            <programmatic-workshop-tab-section />
          </b-tab>
          <b-tab
            title="Colloquia & Seminars"
            :active="getDetailActiveTab === 'colloquia_seminars_programs'"
            @click.prevent="setDetailCurrentTab('colloquia_seminars_programs', 'program-detail-tab-id')"
          >
            <colloquia-and-seminars-tab-section />
          </b-tab>
          <b-tab
            title="Members"
            :active="getDetailActiveTab === 'members'"
            @click.prevent="setDetailCurrentTab('members', 'program-detail-tab-id')"
          >
            <program-member-tab-section :data="datas"/>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <b-modal
      ref="tabFormModal"
      id="tabFormModal"
      size="lg"
      title="Tab Edit"
      centered
      hide-footer
    >
      <detail-tab-form
        :type="'programs'"
        :refId="'tabFormModal'"
        :modalData="tabModal"
      />
    </b-modal>
  </div>
</template>

<script>
import OverviewTabSection from "./OverviewTabSection.vue"
import ProgramLogisticsTabSection from "./ProgramLogisticsTabSection.vue"
import ProgrammaticWorkshopTabSection from "./ProgrammaticWorkshopTabSection.vue"
import ColloquiaAndSeminarsTabSection from "./ColloquiaAndSeminarsTabSection.vue"
import ScheduleAndNotesTabSection from "./ScheduleAndNotesTabSection.vue"
import ProgramVideoTabSection from "./ProgramVideoTabSection.vue"
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"
import ProgramMemberTabSection from "./ProgramMemberTabSection.vue"
import DetailTabForm from "@/components/CommonPages/DetailApplyButtonForm/DetailTabForm.vue"

export default {
	components: {
		OverviewTabSection,
		ProgramLogisticsTabSection,
		ProgrammaticWorkshopTabSection,
		ColloquiaAndSeminarsTabSection,
		ScheduleAndNotesTabSection,
		ProgramVideoTabSection,
		ProgramMemberTabSection,
		DetailTabForm,
	},
	name: "TabsSection",
	props: ["datas", "tabModal", "loadingProgram"],
	data() {
		return {
			tabs: [
				"#overview_programs",
				"#program_logistics_programs",
				"#notes_programs",
				"#videos_programs",
				"#programmatic_workshops_programs",
				"#colloquia_seminars_programs",
				"#members",
			],
		}
	},
	mixins: [mixin],
	mounted() {
		if (this.tabs.indexOf(this.$route.hash) !== -1) {
			var hashPath = this.$route.hash
			this.setDetailCurrentTab(hashPath.substring(1), "program-detail-tab-id")
		}
		this.$root.$on("tabFormModal", () => {
			this.$refs.tabFormModal.hide()
			//that.applyNowRights()
		})
	},
	computed: {
		...mapGetters(["canEditCms", "getDetailActiveTab"]),
	},
}
</script>
